import React from 'react';
import { Page, Text, View, Image } from '@react-pdf/renderer';
import { styles } from './styles';
import { peicarLogo } from '../../../Assets/Images';

export const PageLayout = ({ data, children }) => {
    const t = data.tenant;
    const contractNumber = t.numeroContrato;

    return (
        <Page size="LETTER" style={styles.page}>
            {/* Background Image */}
            <Image src={peicarLogo} style={styles.backgroundImage} fixed />

            {/* Header */}
            <View style={styles.header} fixed>
                <Image src={peicarLogo} style={styles.logo} />
                <Text style={{ fontSize: 8 }}>Contrato No. {contractNumber || 'S/N'}</Text>

            </View>

            <Text style={{ fontSize: 6, fontFamily: 'Helvetica-Oblique', textAlign: 'justify', marginBottom: 8, borderBottom: '1px solid #34C6F1' }}>
                Que celebran de una parte CONDUCE CAPITAL, S.A.P.I. DE C.V., a quien se describe e identifica en el apartado de declaraciones del Contrato (en lo
                sucesivo identificado como el “ARRENDADOR”), por la otra parte, la persona que se describe e identifica en la presente Carátula (a quien en lo sucesivo
                se le denominará el “ARRENDATARIO”), conviniendo ambas partes en considerar esta Carátula como parte integral del Contrato que regula y
                considerándola como si a la letra se insertase en dicho instrumento.
            </Text>


            {/* Content */}
            {children}

            {/* Footer & Page Numbers */}
            <Text
                style={styles.pageNumber}
                render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
                fixed
            />
            <View style={styles.footer} fixed>
                <Text>Este documento es confidencial y propiedad de PEICAR. | {contractNumber}</Text>
            </View>
        </Page>
    );
};
